import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

export default function Navbar({ brand, nav }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-[#f5ebd6]/95 backdrop-blur-sm shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-4 flex items-center justify-between">
        <a href="#home" className="flex items-center gap-3">
          <img
            src={brand.logo}
            alt={brand.name}
            className="w-12 h-12 rounded-full object-cover ring-1 ring-[#a08862]/40"
          />
          <span
            className={`font-serif-display text-2xl md:text-[28px] ${
              scrolled ? "text-[#2a2a2a]" : "text-white"
            }`}
          >
            {brand.name}
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {nav.map((n) => (
            <a
              key={n.label}
              href={n.href}
              className={`text-[13px] tracking-tight-wide font-medium transition-colors hover:text-[#a08862] ${
                scrolled ? "text-[#2a2a2a]" : "text-white"
              }`}
            >
              {n.label}
            </a>
          ))}
        </nav>

        <button
          onClick={() => setOpen(!open)}
          className={`md:hidden ${scrolled ? "text-[#2a2a2a]" : "text-white"}`}
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#f5ebd6] border-t border-[#a08862]/20">
          <div className="px-6 py-4 flex flex-col gap-4">
            {nav.map((n) => (
              <a
                key={n.label}
                href={n.href}
                onClick={() => setOpen(false)}
                className="text-[13px] tracking-tight-wide font-medium text-[#2a2a2a]"
              >
                {n.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
